import { firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  OrganizationInfo,
  RegistrationRider,
  RiderEligibilityProofRequest,
  RiderEligibilityProofResponse,
  RiderService
} from '@uzurv/rideWss/clara';
import { LoadingDialogService } from '../loading-dialog/loading-dialog.service';
import { ServiceException } from '@uzurv/rideWss/app/exceptions';
import { isNullOrUndefined } from '@uzurv/rideWss/app/util';

@Injectable({
  providedIn: 'root'
})
export class SignupService {
  private _hasDeepLinkData: boolean = false;
  private _registrationRider: RegistrationRider;
  private _organizationInfos: Array<OrganizationInfo>;

  constructor(
    private loadingDialogService: LoadingDialogService,
    private translateService: TranslateService,
    private riderService: RiderService
  ) {
    this.resetSignup();
  }

  get hasDeepLinkData(): boolean {
    return this._hasDeepLinkData;
  }

  set hasDeepLinkData(value: boolean) {
    this._hasDeepLinkData = value;
  }

  getRegistrationRider(): RegistrationRider {
    return this._registrationRider;
  }

  getOrganizationInfos(): Array<OrganizationInfo> {
    return this._organizationInfos;
  }

  setOrganizationInfos(organizationInfos: Array<OrganizationInfo>) {
    this._organizationInfos = organizationInfos;
  }

  resetSignup() {
    this._registrationRider = new RegistrationRider();
    this._hasDeepLinkData = false;
  }

  async proofEligibility(partnerIdentifier: string): Promise<RegistrationRider> {
    await this.loadingDialogService.presentLoadingDialog(this.translateService.instant('dialog.loading'));
    try {
      const riderEligibilityProofRequest: RiderEligibilityProofRequest = new RiderEligibilityProofRequest();
      riderEligibilityProofRequest.firstName = this.getRegistrationRider().user.person.firstName;
      riderEligibilityProofRequest.lastName = this.getRegistrationRider().user.person.lastName;
      riderEligibilityProofRequest.dateOfBirth = this.getRegistrationRider().user.person.dateOfBirth;
      riderEligibilityProofRequest.phoneNumber = this.getRegistrationRider().user.person.phoneNumber;
      riderEligibilityProofRequest.emailAddress = this.getRegistrationRider().user.person.emailAddress;
      riderEligibilityProofRequest.partnerIdentifier = partnerIdentifier;

      const riderEligibilityProofResponse: RiderEligibilityProofResponse = await firstValueFrom(
        this.riderService.proofEligibility(riderEligibilityProofRequest)
      );

      await this.loadingDialogService.dismissLoadingDialog();
      if (!isNullOrUndefined(riderEligibilityProofResponse)) {
        this.setOrganizationInfos(riderEligibilityProofResponse.organizationInfos);
        this.getRegistrationRider().partnerIdentifier = riderEligibilityProofResponse.partnerIdentifier;
        return this.getRegistrationRider();
      } else {
        throw new ServiceException('Rider not found');
      }
    } catch (e) {
      await this.loadingDialogService.dismissLoadingDialog();
      throw new ServiceException(e);
    }
  }
}
